var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":_vm.size,"type":_vm.color,"icon":_vm.icon,"disabled":_vm.disabled},on:{"click":_vm.handleExport}},[_vm._v(" "+_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }